// IMPORTANT: the codebase has divergent entity-kind unions and they disagree:
//   - lib/sync/entity-store.ts BaseEntityRow.kind: document|collection|canvas|space|conversation (5, no 'recording')
//   - lib/canvas/types/entity.ts EntityKind:        document|canvas|recording|collection|space (5, no conversation)
// Do NOT claim to mirror either — ai-composer defines its OWN minimal union of the kinds it
// actually targets. The only wired consumer is 'document'; 'canvas' is a defined seam.
// This decouples the foundation from the upstream inconsistency (which is out of scope to fix here).
export type EditEntityKind = 'document' | 'canvas';

export type EditAction = 'generate-chart' | 'organize' | 'translate';

export type EditTarget =
  | { kind: 'tiptap-range'; from: number; to: number }
  | { kind: 'canvas-nodes'; nodeIds: string[] };

export interface EditRequest {
  action: EditAction;
  entityKind: EditEntityKind;
  entityId: string;
  target: EditTarget;
  params?: Record<string, string>;
}

export type ReviewMode = 'ghost-write' | 'preview' | 'review' | 'embed' | 'disabled';

export type ReplaceTextOp = { op: 'replace-text'; text: string };
export type EmbedCanvasOp = {
  op: 'embed-canvas';
  canvasId: string;
};
export type EditOp = ReplaceTextOp | EmbedCanvasOp;

export interface EditDeltaData {
  op: EditOp['op'];
  entityKind: EditEntityKind;
  entityId: string;
  target: EditTarget;
  payload: EditOp;
}

export function isReplaceTextOp(op: EditOp): op is ReplaceTextOp {
  return op.op === 'replace-text';
}

export function isEmbedCanvasOp(op: EditOp): op is EmbedCanvasOp {
  return op.op === 'embed-canvas';
}
